import React from 'react';
import { Section } from './ui/Section';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function WhatItIs() {
  const isList = ['Una guía corta y práctica para recuperar calma cuando te supera el día', "Un método para separar 'quién eres' de 'tu rol' y bajar la culpa", 'Protocolos aplicables hoy (sin teoría eterna)'];
  const isNotList = ['Un curso de educación infantil', "'Motivación' o frases bonitas", 'Una terapia (si necesitas ayuda profesional, esto no la sustituye)'];
  return <Section data-id="element-138">
      <FadeIn data-id="element-139">
        <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-10" data-id="element-140">
          Qué es El Permiso (y qué no)
        </h2>
      </FadeIn>

      <div className="grid md:grid-cols-2 gap-10 md:gap-8" data-id="element-141">
        {/* Esto SÍ es */}
        <div data-id="element-142">
          <FadeIn data-id="element-143">
            <h3 className="text-xl font-bold text-charcoal mb-6 flex items-center gap-2" data-id="element-144">
              <span className="text-sage" data-id="element-145">✅</span> Esto SÍ es
            </h3>
          </FadeIn>
          <StaggerContainer className="space-y-5" data-id="element-146">
            {isList.map((item, index) => <StaggerItem key={index} className="flex items-start gap-3" data-id="element-147">
                <Check className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-148" />
                <p className="text-charcoal text-base md:text-lg" data-id="element-149">{item}</p>
              </StaggerItem>)}
          </StaggerContainer>
        </div>

        {/* Esto NO es */}
        <div data-id="element-150">
          <FadeIn data-id="element-151">
            <h3 className="text-xl font-bold text-gray mb-6 flex items-center gap-2" data-id="element-152">
              <span className="opacity-70" data-id="element-153">❌</span> Esto NO es
            </h3>
          </FadeIn>
          <StaggerContainer className="space-y-5" data-id="element-154">
            {isNotList.map((item, index) => <StaggerItem key={index} className="flex items-start gap-3 opacity-70" data-id="element-155">
                <X className="w-5 h-5 text-gray flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-156" />
                <p className="text-gray text-base md:text-lg" data-id="element-157">{item}</p>
              </StaggerItem>)}
          </StaggerContainer>
        </div>
      </div>
    </Section>;
}